import styled, { css } from 'styled-components';

export const Container = styled.label`
	${({ theme }) => theme.typography.label.medium}
	color: ${({ theme }) => theme.colors.body.light};
	width: fit-content;
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
`;

export const Control = styled.input`
	cursor: pointer;
	all: unset;
	border: 1px solid #ced4da;
	position: relative;
	display: inline-block;
	width: 32px;
	height: 16px;
	border-radius: 15px;
	transition: background-color 0.3s;

	&::before {
		content: '';
		position: absolute;
		top: 2px;
		left: 2px;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: #ced4da;
		transition: left 0.3s;
	}

	${({ checked }) =>
		checked &&
		css`
			border-color: ${({ theme }) => theme.colors.primary.medium};
			background-color: ${({ theme }) => theme.colors.primary.medium};

			&::before {
				left: 18px;
				background-color: ${({ theme }) => theme.colors.neutral.white};
			}
		`}
`;
